"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setReminder = exports.removeReminder = exports.default = void 0;
var types = _interopRequireWildcard(require("../store/actions/actionTypes"));
var _UpdateNotificationsService = _interopRequireDefault(require("../service/UpdateNotificationsService"));
var _PulseApiHelper = _interopRequireDefault(require("../service/PulseApiHelper"));
var _metrics = _interopRequireDefault(require("@adobe/exc-app/metrics"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2022 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any. The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by all applicable intellectual property
 * laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/

let instance;
const metrics = () => instance || (instance = _metrics.default.create('exc.pulse.actions.Reminders'));
/**
 * This method will set the reminder
 * and remove it if the API fails.
 * @param notification
 * @param serverTime
 * @param reminderInMillsecs
 */
const setReminder = (notification, serverTime, reminderInMillsecs) => async dispatch => {
  dispatch({
    type: types.SET_REMINDER_ON_NOTIFICATION,
    payload: {
      id: notification.id,
      reminderTime: serverTime + reminderInMillsecs
    }
  });
  const queryObject = _PulseApiHelper.default.createANSFormatForReminders({
    ...notification,
    reminderTime: serverTime + reminderInMillsecs
  });
  const {
    notification: notifications
  } = await _UpdateNotificationsService.default.updateNotifications([queryObject]);
  if (notifications.length !== 1) {
    dispatch({
      type: types.REMOVE_REMINDER_ON_NOTIFICATION,
      payload: {
        id: notification.id
      }
    });
  } else {
    metrics().event('reminder.set.success', {
      region: window.config && window.config.region
    });
  }
  return notifications.length === 1;
};

/**
 * This API will remove/delete the reminder.
 * @param notification
 */
exports.setReminder = setReminder;
const removeReminder = notification => async dispatch => {
  await dispatch({
    type: types.REMOVE_REMINDER_ON_NOTIFICATION,
    payload: {
      id: notification.id
    }
  });
  const queryObject = _PulseApiHelper.default.createANSFormatForClearReminders(notification);
  const {
    notification: notifications
  } = await _UpdateNotificationsService.default.updateNotifications([queryObject]);
  if (notifications.length !== 1) {
    /**
     * TODO: Error handling needs to be done for this
     */
  } else {
    metrics().event('reminder.removed', {
      region: window.config && window.config.region
    });
  }
  return notifications.length === 1;
};
exports.removeReminder = removeReminder;
var _default = {
  setReminder,
  removeReminder
};
exports.default = _default;